import "twin.macro";

import { ModuleMaintenance } from "./module-maintenance";

const ModuleMaintenancePage = () => {
  return (
    <div tw="flex flex-col items-center gap-6 w-full">
      <ModuleMaintenance />
    </div>
  );
};

export default ModuleMaintenancePage;
